<script setup>
import { toRefs } from 'vue'
import { InputPassword as AInputPassword } from 'ant-design-vue'

const props = defineProps({
  label: {
    type: String
  },
  name: {
    type: String
  },
  modelValue: {
    type: [String, Number]
  },
  required: {
    type: Boolean
  },
  customValidate: {
    type: Boolean
  },
  customValidateText: {
    type: String
  },
  maxlength: {
    type: Number,
    default: null
  },
  autocomplete: {
    type: String,
    default: 'off'
  },
  enterPrevent: {
    type: Boolean,
    default: () => {
      return true
    }
  },
  noRequiredMask: {
    type: Boolean,
    default: () => {
      return false
    }
  }
})

const {
  label,
  name,
  modelValue,
  required,
  customValidate,
  customValidateText,
  enterPrevent,
  autocomplete,
  noRequiredMask
} = toRefs(props)
const enterHandler = (event) => {
  if (enterPrevent.value) event.preventDefault()
}
</script>
<template>
  <label :for="name">
    <p v-if="label" class="flex items-baseline gap-1 py-1">
      <span>{{ label }}</span>
      <span v-if="required && !noRequiredMask" class="text-sm font-light text-red-400">*</span>
    </p>
    <div class="relative">
      <AInputPassword
        ref="passwordInputRef"
        v-bind="$attrs"
        :name="name"
        :id="name"
        :maxlength="maxlength"
        :value="modelValue === 'null' ? null : modelValue"
        @input="$emit('update:modelValue', $event.target.value)"
        @keydown.enter="enterHandler"
        :class="['custom-input', { 'custom-validate-input': customValidate }]"
        :required="required"
        :autocomplete="autocomplete"
      />
      <p v-if="customValidate" class="custom-validate-message">
        {{ customValidateText }}
      </p>
      <input
        class="pointer-events-none absolute bottom-0 right-1/2 -z-50 opacity-0"
        :name="name"
        :value="modelValue"
        :required="required"
        tabindex="-1"
      />
    </div>
  </label>
</template>
<style lang="scss" scoped>
:deep(.ant-input-affix-wrapper) {
  padding: 0;
  border-radius: 4px;

  input.ant-input {
    padding: 0.65rem 0 0.65rem 0.69rem;
    font-family: Verdana, sans-serif;
    font-size: 15px;
    border-radius: 4px 0px 0px 4px;
    line-height: inherit;
  }

  .ant-input-suffix {
    margin-inline-start: 0.69rem;
    margin-inline-end: 0.69rem;
  }
}

:deep(.ant-input-affix-wrapper-disabled) {
  background-color: #eeeeee;
}
:deep(.ant-input) {
  &.ant-input-disabled {
    color: #6a7282;
    background-color: #eeeeee;
  }
}
</style>
